
import RegisterForm from "@/components/RegisterForm.vue";

export default {
  name: "RegisterSite",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    RegisterForm,
  },
};
